import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';

type ListItemRoleType = 'button' | 'menuitem';

export interface IListItemProps {
  key: string | number;
  button?: boolean;
  role?: ListItemRoleType;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const StyledListItem = styled.li`
  display: flex;
  align-items: center;
  position: relative;
  text-decoration: none;
  padding: 4px 16px;
`;

const ButtonListItem = StyledListItem.extend`
  cursor: pointer;
  user-select: none;
  outline: none;
  &:hover,
  &:focus {
    text-decoration: none;
    background-color: ${colors.lithium_light__e2e6ef};
  }
  &[disabled] {
    cursor: not-allowed;
    &:hover,
    &:focus {
      text-decoration: none;
      background-color: inherit;
    }
  }
`;

class ListItem extends React.PureComponent<IListItemProps, {}> {
  public render() {
    const role = this.props.role ? this.props.role : this.props.button ? 'button' : '';
    const ComponentMain = role ? ButtonListItem : StyledListItem;
    return (
      <ComponentMain
        key={this.props.key}
        tabIndex={this.props.button ? 0 : -1}
        role={role}
        onClick={this.props.onClick}
        style={this.props.style}
        // disabled={this.props.disabled}
      >
        {this.props.children}
      </ComponentMain>
    );
  }
}

export default ListItem;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/base/List/ListItem.tsx